import { Empty, Flex, Typography } from "antd";
import { Card } from "../../../common/components/Card";
import { WorkOrderPeopleTable } from "../../reports/WorkOrderPeopleTable";
import { WorkOrderTotalsStatistics } from "../../reports/WorkOrderTotalsStatistics";
import type { TurbineViewRenderProps } from "./TurbineViewRender";

export const WorkSummaryInfo = ({ intl, turbineData }: TurbineViewRenderProps) => {
  const { workSummary, workSummaryStatus } = turbineData;
  const loading = workSummaryStatus === "loading";

  return (
    <Card title={intl.formatMessage({ id: "turbine_work_summary" })}>
      {workSummaryStatus === "failed" ? (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={intl.formatMessage({ id: "turbine_work_summary_load_failed" })}
        />
      ) : (
        <Flex vertical gap="large">
          <WorkOrderTotalsStatistics
            intl={intl}
            totals={workSummary}
            loading={loading && !workSummary}
          />
          <Flex vertical gap="small">
            <Typography.Title level={5}>
              {intl.formatMessage({ id: "work_order_totals_technicians" })}
            </Typography.Title>
            <WorkOrderPeopleTable
              intl={intl}
              people={workSummary?.technicians}
              loading={loading}
            />
          </Flex>
        </Flex>
      )}
    </Card>
  );
};
